/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Frame Stepper",
  "description": "Adds a frame stepping button that appears when paused, allowing you to advance the project by exactly one frame at a time for precise debugging.",
  "credits": [
    {
      "name": "Mistium",
      "url": "https://mistium.com"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [
    "developer"
  ],
  "enabledByDefault": true
};
export default manifest;
